//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { FeedValidationError } from '@apis/catalog-validation/catalogValidationModel';

export const formatErrorLabel = (error: FeedValidationError): string => {
  const errorWords = error.toString().split('_');
  const parsedErrorWords = errorWords.map((word) => {
    return word.charAt(0) + word.substring(1).toLowerCase();
  });
  return parsedErrorWords.join(' ');
};
